import { getStoredPercentageDue } from '@payaca/helpers/storedPaymentSchedule';
import { getAllocatedPercentage } from '@payaca/helpers/paymentScheduleHelper';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { withDeposit } from './stageHelpers';
import { PaymentScheduleFormValues } from './types';

export const usePaymentScheduleStages = () => {
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext<PaymentScheduleFormValues>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'paymentSchedule.stages',
  });
  const stages = useWatch({ control, name: 'paymentSchedule.stages' });

  const allocatedPercentage = getAllocatedPercentage(
    stages.map((stage) => ({ percentageDue: getStoredPercentageDue(stage) }))
  );
  const remainingPercentage = 100 - allocatedPercentage;

  const addStage = () =>
    append({
      type: 'instalment',
      description: '',
      percentageDue: Math.max(remainingPercentage, 0),
    });

  const setFirstStageIsDeposit = (isDeposit: boolean) => {
    if (!stages[0]) return;
    setValue('paymentSchedule.stages.0', withDeposit(stages[0], isDeposit), {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  return {
    fields,
    stages,
    allocatedPercentage,
    remainingPercentage,
    addStage,
    removeStage: remove,
    setFirstStageIsDeposit,
    // Cross-stage schema issues (sum over 100%, deposit placement) land on the
    // stages array itself, which react-hook-form surfaces under `root`.
    stagesErrorMessage: errors.paymentSchedule?.stages?.root?.message,
  };
};
